import { Link } from "react-router-dom";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { IMG } from "../lib/assets";
import { Reveal } from "./Motion";

const Tile = ({ className = "", children, testId }) => (
  <div data-testid={testId} className={`relative overflow-hidden ${className}`}>{children}</div>
);

export const Bento = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section ref={ref} className="bg-white px-5 sm:px-10 lg:px-16 py-24 md:py-32" data-testid="bento-section">
      <Reveal className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-12">
        <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.9]">
          Built for the <span className="text-[#E10600]">squad.</span>
        </h2>
        <p className="max-w-sm font-semibold text-zinc-700">Every stitch made to stand out in a crowd — from the first song to the last call.</p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-4 md:grid-rows-[repeat(2,minmax(260px,1fr))] gap-4">
        <Reveal className="md:col-span-2 md:row-span-2">
          <Tile testId="bento-guy" className="h-[520px] md:h-full bg-[#F6F3EF]">
            <motion.img style={{ y }} src={IMG.guy} alt="Squad member tipping his Project X hat" className="absolute inset-0 w-full h-[112%] -top-[6%] object-cover object-top" />
            <div className="absolute left-0 bottom-0 bg-[#E10600] text-white px-5 py-4 font-display uppercase text-3xl sm:text-4xl">Tip it. Rock it.</div>
          </Tile>
        </Reveal>
        <Reveal delay={0.08}>
          <Tile testId="bento-side" className="h-[300px] md:h-full bg-white border-2 border-[#0B0B0B]">
            <img src={IMG.hatSide} alt="Side view with #X patch" className="absolute inset-0 w-full h-full object-cover object-[30%_60%]" />
            <span className="absolute top-3 left-3 bg-[#0B0B0B] text-white font-mono-x text-xs uppercase tracking-[0.2em] px-2 py-1">#X Patch</span>
          </Tile>
        </Reveal>
        <Reveal delay={0.12}>
          <Tile testId="bento-adjustable" className="h-[260px] md:h-full bg-[#E10600] text-white p-6 flex flex-col justify-between">
            <span className="font-mono-x uppercase text-xs tracking-[0.25em]">Fit</span>
            <p className="font-display uppercase text-4xl lg:text-5xl xl:text-[3.4rem] leading-[0.9]">One size.<br />Adjust&shy;able.</p>
          </Tile>
        </Reveal>
        <Reveal delay={0.16}>
          <Tile testId="bento-colorway" className="h-[260px] md:h-full bg-[#0B0B0B] text-white p-6 flex flex-col justify-between">
            <span className="font-mono-x uppercase text-xs tracking-[0.25em] text-zinc-300">Colorway</span>
            <div className="flex items-end justify-between gap-4">
              <p className="font-display uppercase text-4xl lg:text-5xl xl:text-[3.4rem] leading-[0.9]">Red <br />& White</p>
              <div className="flex gap-2 shrink-0"><span className="w-8 h-8 bg-[#E10600]" /><span className="w-8 h-8 bg-white" /></div>
            </div>
          </Tile>
        </Reveal>
        <Reveal delay={0.2}>
          <Link to="/coming-soon" data-testid="bento-next-drop-link" className="group block h-[260px] md:h-full bg-white border-2 border-[#0B0B0B] p-6 transition-colors duration-300 hover:bg-[#0B0B0B]">
            <div className="h-full flex flex-col justify-between">
              <span className="font-mono-x uppercase text-xs tracking-[0.25em] text-[#E10600]">Drop 002</span>
              <p className="font-display uppercase text-4xl lg:text-5xl xl:text-[3.4rem] leading-[0.9] text-[#0B0B0B] transition-colors duration-300 group-hover:text-white">Coming <span className="text-[#E10600]">soon</span> →</p>
            </div>
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
